(function () {
  var sections = document.querySelectorAll("[data-promo-landing]");

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function hidePromoFloatingTabs() {
    var selectors = [
      "[aria-label*='Claim 10% Off']",
      "[title*='Claim 10% Off']",
      "a",
      "button",
      "[role='button']"
    ];

    var seen = new Set();

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (seen.has(node)) {
          return;
        }

        seen.add(node);

        var text = (node.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        var label = ((node.getAttribute("aria-label") || "") + " " + (node.getAttribute("title") || ""))
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();

        if (text !== "claim 10% off" && !label.includes("claim 10% off")) {
          return;
        }

        var container =
          node.closest("[style*='position: fixed']") ||
          node.closest("[style*='position:fixed']") ||
          node.closest("[class*='sticky']") ||
          node.closest("[class*='popup']") ||
          node.closest("[class*='embed']") ||
          node.closest("div");

        if (container) {
          container.style.display = "none";
        } else {
          node.style.display = "none";
        }
      });
    });
  }

  function startPromoFloatingTabWatcher() {
    hidePromoFloatingTabs();
    window.setTimeout(hidePromoFloatingTabs, 400);
    window.setTimeout(hidePromoFloatingTabs, 1200);
    window.setTimeout(hidePromoFloatingTabs, 2400);

    if ("MutationObserver" in window && document.body) {
      var pending = false;
      var observer = new MutationObserver(function () {
        if (pending) {
          return;
        }

        pending = true;
        window.setTimeout(function () {
          pending = false;
          hidePromoFloatingTabs();
        }, 180);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style", "aria-label", "title"]
      });

      window.setTimeout(function () {
        observer.disconnect();
      }, 6000);
    }
  }

  function hideGlobalFooter() {
    [
      ".section-group-footer-group",
      ".shopify-section-group-footer-group",
      "#shopify-section-footer-group",
      "footer",
      "footer.footer",
      ".footer"
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.style.display = "none";
        node.style.margin = "0";
        node.style.padding = "0";
        node.style.minHeight = "0";
      });
    });
  }

  sections.forEach(function (section) {
    hideGlobalFooter();
    startPromoFloatingTabWatcher();

    var endValue = section.dataset.countdownEnd;
    var countdownParts = {
      days: section.querySelector("[data-countdown-part='days']"),
      hours: section.querySelector("[data-countdown-part='hours']"),
      minutes: section.querySelector("[data-countdown-part='minutes']"),
      seconds: section.querySelector("[data-countdown-part='seconds']")
    };

    if (endValue && countdownParts.days) {
      var endTime = Date.parse(endValue);

      if (!Number.isNaN(endTime)) {
        var tick = function () {
          var diff = Math.max(0, endTime - Date.now());
          countdownParts.days.textContent = pad(Math.floor(diff / 86400000));
          countdownParts.hours.textContent = pad(Math.floor(diff / 3600000) % 24);
          countdownParts.minutes.textContent = pad(Math.floor(diff / 60000) % 60);
          countdownParts.seconds.textContent = pad(Math.floor(diff / 1000) % 60);
        };

        tick();
        window.setInterval(tick, 1000);
      }
    }

    var stickyBar = section.querySelector("[data-sticky-bar]");
    var stickyButton = stickyBar ? stickyBar.querySelector(".promo-landing__sticky-button") : null;
    var heroTrigger = section.querySelector("[data-hero-block]") || section.querySelector("[data-hero-cta]");
    var footerTrigger = section.querySelector("[data-footer-cta]");
    var offersSection = section.querySelector("#deal");

    if (stickyButton && offersSection) {
      stickyButton.addEventListener("click", function (event) {
        var href = stickyButton.getAttribute("href");

        if (href !== "#deal") {
          return;
        }

        event.preventDefault();
        offersSection.scrollIntoView({ behavior: "smooth", block: "start" });
        offersSection.classList.remove("is-highlighted");

        window.requestAnimationFrame(function () {
          offersSection.classList.add("is-highlighted");
        });

        window.setTimeout(function () {
          offersSection.classList.remove("is-highlighted");
        }, 2200);
      });
    }

    if (!stickyBar || !heroTrigger || !footerTrigger || !("IntersectionObserver" in window)) {
      return;
    }

    var heroPast = false;
    var footerVisible = false;
    var offersVisible = false;

    function syncSticky() {
      heroPast = heroTrigger.getBoundingClientRect().bottom <= 0;
      stickyBar.classList.toggle("is-visible", heroPast && !footerVisible && !offersVisible);
    }

    new IntersectionObserver(
      function (entries) {
        syncSticky();
      },
      { threshold: 0 }
    ).observe(heroTrigger);

    new IntersectionObserver(
      function (entries) {
        offersVisible = entries[0].isIntersecting;
        syncSticky();
      },
      { threshold: 0.15 }
    ).observe(offersSection);

    new IntersectionObserver(
      function (entries) {
        footerVisible = entries[0].isIntersecting;
        syncSticky();
      },
      { threshold: 0.2 }
    ).observe(footerTrigger);

    window.addEventListener("scroll", syncSticky, { passive: true });
    window.addEventListener("resize", syncSticky);
    syncSticky();
  });
})();
